import BootcampInstanceQuiz from '../api/bootcampInstanceQuiz';
import { applicationSave, applicationFetch, applicationUpdate, applicationFetchAll } from './applicationActions';

export const saveBootcampInstanceQuiz = applicationSave(BootcampInstanceQuiz);
export const fetchBootcampInstanceQuiz = applicationFetch(BootcampInstanceQuiz);
export const updateBootcampInstanceQuiz = applicationUpdate(BootcampInstanceQuiz);
export const fetchBootcampInstanceQuizzes = applicationFetchAll(BootcampInstanceQuiz);
